// src/components/modals/ManualOrderModal.jsx
import React, { useState } from 'react';
import { FiX, FiCheckCircle, FiFileText, FiUser, FiBriefcase, FiDollarSign } from 'react-icons/fi';
import { toast } from 'react-hot-toast';
import { OrderExecutionEngine } from '../../api/OrderExecutionEngine';

export default function ManualOrderModal({ leadSource, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        clienteId: leadSource?._id || '',
        razaoSocial: leadSource?.razaoSocial || leadSource?.name || leadSource?.nome || '',
        cnpj: leadSource?.cnpj || '',
        email: leadSource?.email || '',
        telefone: leadSource?.telefone || leadSource?.phone || '',
        plano: '',
        valor: '',
        qtdeLinhas: leadSource?.qtdeLinhas || 1,
        porte: leadSource?.empresaPorte || 'PME',
        origemLead: leadSource?.source || 'MANUAL'
    });

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Simulando delay de segurança 
        toast.loading("Forjando protocolo de pedido...", { id: 'order_create' });

        const result = await OrderExecutionEngine.criarPedidoManual(formData);

        if (result) {
            toast.success("Pedido forjado com sucesso!", { id: 'order_create' });
            if (onSuccess) onSuccess(result);
            else onClose();
        } else {
            toast.error("Falha ao criar o pedido. Contate o Comando.", { id: 'order_create' });
        }
        
        setLoading(false);
    };

    return (
        <div 
            className="fixed inset-0 z-[200] flex items-center justify-center p-4"
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="absolute inset-0 bg-black/80 backdrop-blur-md" onClick={onClose}></div>
            
            <div className="relative w-full max-w-xl bg-gray-900 border border-white/10 rounded-2xl shadow-2xl overflow-hidden flex flex-col">
                
                {/* HEADER */}
                <div className="flex justify-between items-center p-5 border-b border-white/10 bg-black/50">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-yellow-500/20 text-yellow-500 rounded-lg">
                            <FiFileText size={20} />
                        </div>
                        <div>
                            <h2 className="text-lg font-black text-white tracking-widest uppercase">FORJAR PEDIDO</h2>
                            <p className="text-xs text-gray-400">Inserção manual no arquivo de contratos</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-white/5 rounded-xl text-gray-400 hover:text-white transition-colors">
                        <FiX size={20} />
                    </button>
                </div>

                {/* BODY (FORM) */}
                <div className="p-6 overflow-y-auto max-h-[70vh]">
                    <form id="manualOrderForm" onSubmit={handleSubmit} className="space-y-4">
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400 flex items-center gap-2">
                                    <FiUser size={12}/> CLIENTE (RAZÃO SOCIAL)
                                </label>
                                <input required type="text" name="razaoSocial" value={formData.razaoSocial} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="Ex: Empresa Tech LTDA" />
                            </div>
                            
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400 flex items-center gap-2">
                                    <FiBriefcase size={12}/> CNPJ / DOC
                                </label>
                                <input type="text" name="cnpj" value={formData.cnpj} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="00.000.000/0001-00" />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400">EMAIL</label>
                                <input type="email" name="email" value={formData.email} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="contato@empresa.com" />
                            </div>
                            
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400">TELEFONE</label>
                                <input type="text" name="telefone" value={formData.telefone} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="(11) 99999-9999" />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2 border-t border-white/5">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400">PLANO CONTRATADO</label>
                                <input required type="text" name="plano" value={formData.plano} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="Ex: TIM Black Empresa 100GB" />
                            </div>
                            
                            <div className="space-y-2">
                                <label className="text-[10px] font-black tracking-widest text-gray-400 flex items-center gap-2">
                                    <FiDollarSign size={12}/> VALOR TOTAL (MRR)
                                </label>
                                <input required type="number" step="0.01" name="valor" value={formData.valor} onChange={handleChange} 
                                    className="w-full bg-black border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500 outline-none transition-all"
                                    placeholder="Ex: 450.00" />
                            </div>
                        </div>

                    </form>
                </div>

                {/* FOOTER */}
                <div className="p-5 border-t border-white/10 bg-black/50 flex gap-3 justify-end">
                    <button onClick={onClose} disabled={loading} className="px-6 py-2.5 rounded-xl font-bold text-sm text-gray-400 hover:text-white transition-colors">
                        CANCELAR
                    </button>
                    <button type="submit" form="manualOrderForm" disabled={loading} 
                        className="flex items-center gap-2 px-6 py-2.5 bg-yellow-500 hover:bg-yellow-400 text-black font-black text-sm uppercase tracking-widest rounded-xl transition-all shadow-[0_0_20px_rgba(234,179,8,0.3)] disabled:opacity-50">
                        {loading ? <span className="animate-spin text-xl">⚙</span> : <FiCheckCircle size={18} />}
                        EFETIVAR CONTRATO
                    </button>
                </div>

            </div>
        </div>
    );
}
